import { SERVER_API } from "../../Constant";
import axios from "axios";

export const FetchReportByInquiry_api = async (inquiryId: string) => {
    try {
        const response = await axios.get(
            `${SERVER_API}/Reports/fetch_report_by_inquiry.php`,
            {
                headers: {
                    "Content-Type": "application/json",
                },
                params: {
                    inquiryId,
                },
            }
        );

        return response.data;
    } catch (error: any) {
        console.error("Fetch report by inquiry failed:", error);
        return { error: "Fetch report by inquiry failed" };
    }
};
